import React, { useState, useEffect, useRef } from 'react';
import { SearchBox } from 'react-instantsearch-dom';
import { useLocation } from 'react-router-dom';
import './UnconnectedSearchBar.css';
import SearchResultDropdown from './SearchResultDropdown';

type Props = {
  onSubmit?: () => void
};

const UnconnectedSearchBar = ({ onSubmit }: Props) => {
  const [query, setQuery] = useState(null)
  const [showDropdown, setShowDropdown] = useState(true);
  const location = useLocation();
  const wrapperRef = useRef(null);

  const onSubmitSearch = (e) => {
    e.preventDefault();
    onSubmit(query);
  };

  useEffect(() => {
    setShowDropdown(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={wrapperRef}>
      <SearchBox
        className="one"
        searchAsYouType={true}
        translations={{ placeholder: 'O que está procurando?' }}
        onChange={(e) => {
          setShowDropdown(true);
          setQuery(e.target.value)
        }}
        onSubmit={onSubmitSearch}
      />
      {showDropdown && <SearchResultDropdown query={query} onSeeMoreResults={onSubmitSearch} />}
    </div>
  );
}

export default UnconnectedSearchBar;
